module.exports = __webpack_public_path__ + "static/media/quality.ff009f2d.svg";